import React, { useState, useEffect } from "react";
import { showToast } from "../../../Components/ShowToast/ToastNotification";
import { api_url, BACKEND_URL } from "../../../constant/constant";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const UserPoliciesDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [PolicyPdfUrl, setPolicyPdfUrl] = useState("");
  const [Policyversion, setPolicyversion] = useState(""); // ✅ new state added
  const [PolicyId, setPolicyId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [PolicyTitle, setPolicyTitle] = useState("");
  const [Policytype, setPolicytype] = useState("");
  const [Policycontent, setPolicycontent] = useState("");
  const [showPolicy, setShowPolicy] = useState(true);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("userToken");
        const response = await fetch(`${api_url}/user/dashboard`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();
        console.log("API Response:", result);

        if (result.status === "success") {
          if (
            Array.isArray(result.compliance) &&
            result.compliance.length > 0 &&
            Array.isArray(result.compliance[0].policies) &&
            result.compliance[0].policies.length > 0
          ) {
            const policy = result.compliance[0].policies[0];
            setPolicyTitle(policy.title || "");
            setPolicyId(policy.id || "");
            setPolicytype(policy.policy_type || "");
            setPolicycontent(policy.content || "");
            setPolicyPdfUrl(policy.pdf_url || ""); // ✅ added
            setPolicyversion(policy.version || ""); // ✅ added
            setShowPolicy(true);
          } else {
            setShowPolicy(false);
          }
        }
      } catch (err) {
        console.error("Fetch error:", err);
        showToast(t("somethingwentwrongpleaserefresh"), "error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleSavePolicy = async () => {
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(
        `${api_url}/user/mark-policy-as-read/${PolicyId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();
      console.log("Policy Save Response:", result);

      if (result.status === "success") {
        showToast(t("policyhasbeenmarkedasread"), "success");
        setShowPolicy(false);
        navigate(-1);

      } else {
        showToast(t("failedtosavepolicy"), "error");
      }
    } catch (err) {
      console.error("Save Policy error:", err);
      showToast(t("somethingwentwrongwhilesavingthepolicy"), "error");
    }
  };
return (
  <div className="dashboard-container p-4">
    {isLoading ? (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">{t("Loading")}...</span>
        </div>
      </div>
    ) : (
      <>
        {showPolicy && (
          <div>
            <div
              className="policy-section col-md-10"
              style={{
                border: "1px solid #EAEAEA",
                borderRadius: "10px",
                padding: "15px 25px",
              }}
            >
              {/* ✅ Policy Title */}
              <h5 style={{ fontWeight: "600", color: "#333" }}>{PolicyTitle}</h5>

              {/* ✅ Version (always visible) */}
              {Policyversion && (
                <p style={{ marginBottom: "10px" }}>
                  <strong>{t("Version")}:</strong> {Policyversion}
                </p>
              )}
              <hr />

              {/* ✅ Policy Display */}
              {Policytype === "HTML" ? (
                <div
                  dangerouslySetInnerHTML={{ __html: Policycontent }}
                ></div>
              ) : Policytype === "PDF" ? (
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ padding: "40px 0" }}
                >
                  <i
                    className="bi bi-file-earmark-pdf-fill"
                    style={{
                      fontSize: "80px",
                      color: "#d32f2f",
                      cursor: "pointer",
                      transition: "transform 0.2s ease",
                    }}
                    title={t("Open PDF")}
                    onClick={() =>
                      window.open(`${BACKEND_URL}${PolicyPdfUrl}`, "_blank")
                    }
                    onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                    onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                  ></i>
                  <p className="mt-3" style={{ fontWeight: "500" }}>
                    {t("ClicktoOpenPolicyPDF")}
                  </p>
                </div>
              ) : (
                <p>{Policycontent}</p>
              )}
            </div>

            {/* ✅ Checkbox + Save */}
            <div className="mt-3" style={{ marginLeft: "0%" }}>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="policyCheck"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="policyCheck">
                  {t("IAgreetothePolicyCampaign")}
                </label>
              </div>

              <button
                className="btn btn-primary mt-2"
                onClick={handleSavePolicy}
                disabled={!isChecked}
              >
                {t("AcceptPolicyCampaign")}
              </button>
            </div>
          </div>
        )}
      </>
    )}
  </div>
);


};

export default UserPoliciesDetails;
